import { clsx } from 'clsx';
import { ReactNode } from 'react';

import styles from './SkillGauge.module.scss';

interface SkillGaugeParams {
  label?: string;
  level: number;
  color?: string;
  popupText?: string;
}

const SkillGauge = ({
  label = '',
  level,
  color = 'var(--bg-color, #0572ce)',
}: SkillGaugeParams) => {
  const levels: ReactNode[] = [];

  for (let i = 0; i < Math.floor(level); i++) {
    levels.push(
      <span className={styles['skill-bubble']} key={`level${i}`}></span>,
    );
  }

  // add half if fractional
  if (level && level % 1 !== 0)
    levels.push(
      <span
        className={`${styles['skill-bubble']} ${styles.half}`}
        key={`level${levels.length}`}
      ></span>,
    );

  if (levels.length < 5) {
    for (let i = levels.length; i < 5; i++) {
      levels.push(
        <span
          className={`${styles['skill-bubble']} ${styles.empty}`}
          key={`level${i}`}
        ></span>,
      );
    }
  }

  return (
    <div
      className={clsx(styles['skill-gauge'], 'skill-gauge')}
      style={{ color: color }}
    >
      {label && <span className={styles['skill-title']}>{label}</span>}
      {levels.map((level) => level)}
    </div>
  );
};

export default SkillGauge;
